import CommercialDashboardAPI from '../../api/commercialDashboard';

const state = {
  overview: null,
  requestId: 0,
  uiFlags: {
    isFetchingOverview: false,
    fetchError: null,
  },
};

const getters = {
  getOverview: $state => $state.overview,
  getUIFlags: $state => $state.uiFlags,
};

const mutations = {
  RESET($state) {
    $state.requestId += 1;
    $state.overview = null;
    $state.uiFlags = { isFetchingOverview: false, fetchError: null };
  },
  START_REQUEST($state) {
    $state.requestId += 1;
    $state.overview = null;
    $state.uiFlags = { isFetchingOverview: true, fetchError: null };
  },
  SET_OVERVIEW($state, data) {
    $state.overview = data;
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

const actions = {
  async fetchOverview({ commit, state: $state }, params = {}) {
    commit('START_REQUEST');
    const requestId = $state.requestId;
    try {
      const { data } = await CommercialDashboardAPI.overview(params);
      if (requestId === $state.requestId) commit('SET_OVERVIEW', data);
      return data;
    } catch (error) {
      if (requestId === $state.requestId) {
        commit('SET_UI_FLAG', {
          fetchError: 'Não foi possível carregar os dados. Tente novamente.',
        });
      }
      throw error;
    } finally {
      if (requestId === $state.requestId) {
        commit('SET_UI_FLAG', { isFetchingOverview: false });
      }
    }
  },
};

export default { namespaced: true, state, getters, mutations, actions };
